import React from 'react';
import { IconProps } from './types';

const PlayO: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M16 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM16 1.35c-8.1 0-14.65 6.55-14.65 14.65s6.55 14.65 14.65 14.65 14.65-6.55 14.65-14.65-6.55-14.65-14.65-14.65z"
    />
    <path
      fill={!ignoreColor ? color : undefined}
      d="M11.4 9.45v13.1c0 0.6 0.9 0.9 1.45 0.5l8.55-6.7c0.35-0.25 0.35-0.75 0-1l-8.5-6.4c-0.6-0.4-1.5-0.1-1.5 0.5z"
    />
  </svg>
);

export default PlayO;
